import React, { useEffect, useState } from 'react';
// import YTLoader from 'youtube-iframe';
import { PlayerType } from '@sscale/syncsdk';
import './Player.css';

import { setClientToSdk, startSynchronize, selectGroupName } from "../../services/syncService";
import { useSelector } from 'react-redux';
import iOS from "../../helper/iosDetect";

const Player = ({isCelebrity}) => {

  const { stream, userName = '', roomLink } = useSelector(state => state.participant);

  const [playerInfo, setPlayerInfo] = useState({
    id: 'stream-id',
    videoUrl: process.env.REACT_APP_STREAM_URL,
  })

  useEffect(() => {

    const videoURL = process.env.REACT_APP_STREAM_URL;

    if(videoURL) {
      const video = document.getElementById('stream');
      video.volume = 0.15;
      // if(iOS() === true){
      //   setTimeout(() => {
      //     if(video){
      //       video.play();
      //     }
      //   }, 2000)
      // }

      const last = roomLink.lastIndexOf('/')

      selectGroupName(roomLink.slice(last + 1), userName);

      setClientToSdk({
        id: 'stream',
        videoUrl: videoURL,
        playerType: PlayerType.html
      });

      if(!isCelebrity)
          startSynchronize()
    }

  }, [])

  return (
    <div className='player-container'>
        <video
          id='stream'
          width="100%" height="100%"
          autoPlay
          controls={true}
        >
        </video>
    </div>
  );
};
export default Player;
